import React from "react";
import { useLang } from "@/context/LangContext";
import { ScrollText, Scale, FileSignature, Shield, Heart, Briefcase } from "lucide-react";

const ICONS = [ScrollText, Scale, FileSignature, Shield, Heart, Briefcase];

const Services = () => {
  const { t } = useLang();
  return (
    <section id="services" className="py-24 md:py-32 bg-[#F3EFE9]/60 relative">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-16">
          <div className="lg:col-span-5">
            <p className="overline">{t.services.overline}</p>
            <h2 className="display mt-5 text-4xl md:text-5xl lg:text-6xl text-[#1A0010] whitespace-pre-line">
              {t.services.title}
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-12">
            <div className="hairline-strong w-24 mb-6" />
            <p className="text-[15px] md:text-base text-[#4D3D46] leading-relaxed max-w-2xl">
              Practica este organizată pe șase arii principale, fiecare beneficiind de aceeași
              rigoare procesuală și atenție personalizată — de la consultații strategice până la
              reprezentarea în cauze complexe.
            </p>
          </div>
        </div>

        {/* Grid Borders */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-l border-t border-[#D4AF37]/30">
          {t.services.items.map((item, idx) => {
            const Icon = ICONS[idx % ICONS.length];
            return (
              <div
                key={idx}
                className="group cell hover:bg-[#66023C] hover:text-[#FBF9F6] transition-colors duration-500"
                data-testid={`service-card-${idx}`}
              >
                <div className="flex items-start justify-between mb-6">
                  <span className="serif text-5xl text-[#D4AF37] group-hover:text-[#D4AF37]">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  <Icon
                    size={28}
                    strokeWidth={1}
                    className="text-[#66023C] group-hover:text-[#D4AF37] transition-colors"
                  />
                </div>
                <h3 className="serif text-2xl md:text-3xl text-[#1A0010] group-hover:text-[#FBF9F6] mb-3 font-light leading-tight">
                  {item.title}
                </h3>
                <p className="text-sm md:text-[15px] text-[#4D3D46] group-hover:text-[#FBF9F6]/85 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
